import { React, useState, useEffect } from "react";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import LoadingBar from "react-top-loading-bar";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import HTMLToPdfSelectHTMLView from "../html_to_pdf/HTMLToPdfSelectHTMLView";
import HTMLToPDFTabs from "../html_to_pdf/HTMLToPDFTabs";
import { BASE_URL, REQUEST_URL, STATUS_CHECK_INTERVAL } from "../Config";
import {
  createAPIRequest,
  getSignedAWSS3URLToDownloadFile,
  getSignedAWSS3URLToUploadFile,
  uploadFileToAWSS3Server,
} from "../WebUtils";
import { formatBytes, loadFromURLAsBlob } from "../Utils";
import HTMLToImageOutputImageView from "./HTMLToImageOutputImageView";

function HTMLToImageMain() {
  //max file size
  //max .html, .css file size
  const MAX_FILE_SIZE = 2 * 1024 * 1024; //in bytes
  // AppStatus.ts
  const AppState = {
    LOADED: "LOADED",
    PROCESSING: "PROCESSING",
    PROCESSED: "PROCESSED",
    NONE: "NONE",
  };

  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || { title: "Save HTML as Image Free" };

  //html content
  const [html2ImageDetails, setHtml2ImageDetails] = useState({
    state: AppState.NONE,
    webpageURL: "", //requires when convertimg frol url
    htmlFile: null, //requires when convertimg frol html file
    htmlCode: "", //requires when convertimg frol html code
    selectedTab: HTMLToPDFTabs.TAB_CONVERT_WEBPAGE,
    message: "",
  });
  //image file
  const [imageDetails, setImageDetails] = useState({
    imageBlob: null,
  });
  //is converting
  const [isConverting, setIsConverting] = useState(false);
  //set progress
  //top loading bar
  const [progress, setProgress] = useState(0);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: { link: "/html_to_image", title: "HTML To Image Converter" },
    data2: { link: "/html_to_image", title: "Convert HTML To Image" },
    data3: { link: "/html_to_image", title: "HTML To JPG Converter Free" },
  };

  //use effect to handle the submit button click
  useEffect(() => {
    //check
    if (isConverting === true) {
      //set processig
      setHtml2ImageDetails({
        ...html2ImageDetails,
        state: AppState.PROCESSING,
        message: "",
      });
      //convert
      convertHTMLToImage(REQUEST_URL);
    } else {
      //set progress
      setProgress(100);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isConverting]);

  //check status from status from endpoint
  const checkRunpodJobStatus = async (url, job_id) => {
    //check runpod status
    //access token append automatically
    const response = await createAPIRequest(url, "POST", "application/json", {
      request_type: "STATUS_CHECK_HTML_TO_IMAGE",
      job_id: job_id,
    });

    //check
    if (response === null) {
      //set message
      setHtml2ImageDetails({
        ...html2ImageDetails,
        state: AppState.NONE,
        message: "Network error. Check your internet connection and try again.",
      });
      //set
      setIsConverting(false);
      //return
      return;
    }

    console.log("Response: ", response);

    //check success
    if (response.success === true) {
      //check status
      if (response.status === "COMPLETED") {
        //try ctach
        try {
          //resobj
          const convObj = JSON.parse(response.message);
          //image name
          const image_name = convObj.output_file;
          console.log("Image name: ", image_name);

          //check
          if (image_name !== "") {
            //get image url
            const imageDownloadUrlResponse =
              await getSignedAWSS3URLToDownloadFile(url, image_name);
            //check
            if (
              imageDownloadUrlResponse !== null &&
              imageDownloadUrlResponse.success === true
            ) {
              //set output message
              setHtml2ImageDetails({
                ...html2ImageDetails,
                state: AppState.PROCESSED,
                message: "Successfully converted html to image.",
              });
              //set image details
              setImageDetails({
                ...imageDetails,
                imageBlob: await loadFromURLAsBlob(
                  imageDownloadUrlResponse.downloadUrl,
                ),
              });
              //set
              setIsConverting(false);
            } else {
              //set
              setHtml2ImageDetails({
                ...html2ImageDetails,
                state: AppState.NONE,
                message: "Sorry, failed downloading file.",
              });
              //set
              setIsConverting(false);
            }
            console.log("Response: ", imageDownloadUrlResponse);
          } else {
            //set
            setHtml2ImageDetails({
              ...html2ImageDetails,
              state: AppState.NONE,
              message: "Sorry, failed downloading file.",
            });
            //set
            setIsConverting(false);
          }
        } catch {
          //set
          setHtml2ImageDetails({
            ...html2ImageDetails,
            state: AppState.NONE,
            message: "Sorry, failed processing file.",
          });
          //set
          setIsConverting(false);
        }
      } else if (
        response.status === "FAILED" ||
        response.status === "CANCELLED" ||
        response.status === "TIMED_OUT"
      ) {
        //set message
        setHtml2ImageDetails({
          ...html2ImageDetails,
          state: AppState.NONE,
          message:
            response.message === null
              ? "Sorry we couldn't process your request. Invalid request."
              : response.message,
        });

        //set
        setIsConverting(false);
      } else if (
        response.status === "IN_QUEUE" ||
        response.status === "RUNNING" ||
        response.status === "IN_PROGRESS"
      ) {
        //check api after 10 seconds
        setTimeout(() => {
          //callback
          checkRunpodJobStatus(url, job_id);
        }, STATUS_CHECK_INTERVAL);
      }
    } else {
      //set
      setHtml2ImageDetails({
        ...html2ImageDetails,
        state: AppState.NONE,
        message: "Sorry, failed processing file.",
      });
      //set
      setIsConverting(false);
    }
  };

  //convert html to image
  //url = REQUEST_URL
  const convertHTMLToImage = async (url) => {
    //check html file size
    if (
      html2ImageDetails.htmlFile !== null &&
      html2ImageDetails.htmlFile.size > MAX_FILE_SIZE
    ) {
      //set message
      setHtml2ImageDetails({
        ...html2ImageDetails,
        message: `Sorry, we can’t process this file because it exceeds the maximum size limit. Please upload a smaller file. The maximum allowed size is - ${formatBytes(MAX_FILE_SIZE)}`,
      });
      //set
      setIsConverting(false);
      //return
      return;
    }

    //set progress
    setProgress(30);

    //filename
    let uploadFileName = "";
    //check if html file is not null
    if (
      html2ImageDetails.selectedTab === HTMLToPDFTabs.TAB_CONVERT_HTML_FILE &&
      html2ImageDetails.htmlFile !== null
    ) {
      //get signed aws s3 url
      const response = await getSignedAWSS3URLToUploadFile(
        url,
        html2ImageDetails.htmlFile,
      );

      //check
      if (response !== null && response.success === true) {
        //upload file
        const uploadUrl = response.uploadUrl;
        //check
        if (uploadUrl !== null) {
          //upload file
          const fileUploadResponse = await uploadFileToAWSS3Server(
            uploadUrl,
            html2ImageDetails.htmlFile,
          );

          //check response
          if (fileUploadResponse !== null && fileUploadResponse.ok === true) {
            //filename
            //set upload filename
            uploadFileName = response.fileName;
          } else {
            //set message
            setHtml2ImageDetails({
              ...html2ImageDetails,
              state: AppState.NONE,
              message: "Sorry, failed uploading file. Please try again later.",
            });
            //set
            setIsConverting(false);
            //retutn
            return;
          }
        } else {
          //set
          setIsConverting(false);
          //retutn
          return;
        }
      } else {
        //set message
        setHtml2ImageDetails({
          ...html2ImageDetails,
          state: AppState.NONE,
          message:
            response === null
              ? "Network error. Check your internet connection and try again."
              : response.message,
        });
        //set
        setIsConverting(false);
        //retutn
        return;
      }
      //set progress
      setProgress(50);
    }

    //call runpod code
    //call html to image endpoint
    //access token append automatically
    const response = await createAPIRequest(url, "POST", "application/json", {
      request_type: "HTML_TO_IMAGE",
      convert_type: html2ImageDetails.selectedTab.toString(),
      htmlCode: html2ImageDetails.htmlCode,
      webpageURL: html2ImageDetails.webpageURL,
      html_file_name: uploadFileName,
      job_id: null,
    });

    //set progress
    setProgress(70);

    //check
    if (response === null) {
      //set message
      setHtml2ImageDetails({
        ...html2ImageDetails,
        state: AppState.NONE,
        message: "Network error. Check your internet connection and try again.",
      });
      //set
      setIsConverting(false);
      //return
      return;
    }

    console.log("Response: ", response);

    //check
    //if failed
    if (response.success === false) {
      //set message
      setHtml2ImageDetails({
        ...html2ImageDetails,
        state: AppState.NONE,
        message: response.message,
      });
      //set
      setIsConverting(false);
    } else {
      //set token in local storage
      localStorage.setItem("access_token", response.token);
      //set job_id
      const job_id = response.job_id;
      //check response from runpod server
      //when humanize text is completed
      if (
        response.status === "FAILED" ||
        response.status === "CANCELLED" ||
        response.status === "TIMED_OUT" ||
        job_id === null
      ) {
        //set message
        setHtml2ImageDetails({
          ...html2ImageDetails,
          state: AppState.NONE,
          message:
            response.message === null
              ? "Sorry we couldn't process your request. Invalid request."
              : response.message,
        });

        //set
        setIsConverting(false);
      } else {
        //check status for job_id
        checkRunpodJobStatus(url, job_id);
      }
    }
  };

  return (
    <PageContext.Provider
      value={{
        html2ImageDetails,
        setHtml2ImageDetails,
        isConverting,
        setIsConverting,
        imageDetails,
        setImageDetails,
      }}
    >
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar progress={progress} />

      {/*Add title and metadata */}
      <title>{title + " Online"}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="Convert HTML to image online instantly. Turn web pages or HTML code into high quality JPG or PNG images with our fast HTML to image tool."
      ></meta>
      <meta
        name="keywords"
        content="html to image, convert html to image, html to png, html to jpg, web page to image, website to image, html screenshot tool, online html to image, html code to image, capture html to image, html image converter, web to image converter, html render to image, webpage image generator, html to image online, html to jpg online,html to image converter"
      ></meta>

      {/* page content */}
      <div>
        {/* Nav Bar */}
        <NavBar />
        {/* Title */}
        <MiscPageTitle title={title} online={true} />
        {/* Select HTML View */}
        <HTMLToPdfSelectHTMLView
          selectMultiple={false}
        ></HTMLToPdfSelectHTMLView>
        {/* Output Image */}
        <HTMLToImageOutputImageView />
        {/* Mid Section */}
        <MiscPageMidSection description="This HTML to image website makes it easy to convert web pages, HTML files, and UI components into high quality images in just a few clicks. Using a powerful HTML to image converter, users can accurately capture HTML content, CSS styling, fonts, and layouts and export them as JPG, PNG, or WebP images. This tool is ideal for developers, designers, marketers, and content creators who want to save HTML as image for documentation, previews, social media posts, presentations, or client approvals. Our online HTML to image solution removes the need for screenshots or complex browser tools by rendering HTML exactly as it appears on screen. Whether you need to convert a full webpage, a specific HTML element, or a dynamic layout, an HTML to image converter ensures pixel perfect results while preserving visual quality. With fast processing, cross-browser compatibility, and secure handling of data, an HTML to image website is the best choice to save HTML as image efficiently. From generating thumbnails and website previews to sharing code output visually, HTML to image conversion is an essential tool for modern web workflows and visual content creation." />
        {/* How to use */}
        <HomeScreenHowToUse
          steps={{
            step1: "Select",
            step2: "Offline",
            step3: "Convert",
            step4: "Download",
          }}
        />
        {/* Why use section */}
        <MiscWhyUse
          title="HTML To Image Converter"
          why_use={[
            {
              title: "Convert HTML Content into Images",
              description:
                "Our HTML to image tool allows users to convert web pages and HTML layouts into images. Using an HTML to image converter makes it easy to save HTML as image for sharing and presentation.",
            },
            {
              title: "Pixel Perfect Rendering of Web Designs",
              description:
                "HTML to image conversion captures exact layouts, CSS styles, fonts, and colors, ensuring accurate visual output using an HTML to image online tool.",
            },
            {
              title: "Ideal for Documentation and Tutorials",
              description:
                "Developers and educators use HTML to image tools to save HTML as image for guides, manuals, and technical documentation.",
            },
            {
              title: "Website Previews and Thumbnails",
              description:
                "Our HTML to image converter helps generate website previews, thumbnails, and screenshots quickly without manual screen capture.",
            },
            {
              title: "Useful for Social Media and Marketing",
              description:
                "Marketers can convert HTML content into images for social posts, ads, and banners using an HTML to image online solution.",
            },
            {
              title: "No Screenshots or Browser Tools Needed",
              description:
                "Using an HTML to image converter removes the need for browser screenshots, providing cleaner and more consistent results.",
            },
            {
              title: "Save Time and Increase Productivity",
              description:
                "HTML to image online tools automate the process of saving HTML as image, reducing manual work and speeding up workflows.",
            },
            {
              title: "Works Across Devices and Platforms",
              description:
                "Our HTML to image converter works across different devices and browsers, making HTML to image conversion flexible and reliable.",
            },
            {
              title: "High Quality Image Output",
              description:
                "Modern HTML to image tools generate high-resolution images while maintaining sharpness and visual quality.",
            },
          ]}
        />
        {/* Looking for section */}
        <MiscPageLookingFor data={lookingForObject} />
        {/* Footer */}
        <Footer />
      </div>
    </PageContext.Provider>
  );
}

export default HTMLToImageMain;
